import { CSSProperties } from "react";
import { checkedInColors } from "./CheckedInStyles";

export interface CheckedInUser {
    uuid: string;
    employeeUuid: string;
    token: string;
    region: string;
    appVariant: string;
    isClient: boolean;
    firstName: string;
    permissions: number[];
    customBodyAndMindName?: string;
    customMyQuotesName?: string;
    backgroundColor?: string;
    primaryColor?: string;
    companyName?: string;
    companyLogoUrl?: string;
}

export function checkedInTheme(user: CheckedInUser): CSSProperties {
    return {
        "--checked-in-background": user.backgroundColor || checkedInColors.butter,
        "--checked-in-primary": user.primaryColor || checkedInColors.espresso
    } as CSSProperties;
}
